import React from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { getCookie } from "../../serviceWorker";
import { LICENSE_PAGE_URL } from "../../apis/apiConstants";
import { tGenerics } from "../../utils/table";

const [HbrIllustration] = reactWrapper(["hbr-illustration"]);

const FeatureDisabled = ({ title = "", textContent = "", size = "large" }) => {
  const isConvergence = getCookie("cl-analytics");
  const displayTitle = title || tGenerics("auth.restrictedTitle");
  const displaytextContent = textContent || tGenerics("auth.disabled");

  return (
    <HbrIllustration size={size} className="width-full" direction="row">
      <div slot="heading">{displayTitle}</div>
      <div slot="body">
        {displaytextContent}
        {isConvergence && (
          <div>
            {tGenerics("auth.licenseLink.part1")}
            <a href={LICENSE_PAGE_URL} rel="noreferrer noopener" tabIndex="0">
              {tGenerics("auth.licenseLink.part2")}
            </a>
            {tGenerics("auth.licenseLink.part3")}
          </div>
        )}
      </div>
    </HbrIllustration>
  );
};

FeatureDisabled.propTypes = {
  title: PropTypes.string,
  textContent: PropTypes.string,
  size: PropTypes.string,
};

export default FeatureDisabled;
